import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class DeliveryCalendarService {

  // endpoints
  private _deliveryCalendarEp: string = `${this._apiSvc.endpoints.sales}/api/DeliveryCalendarHead`;
  private _deliveryCalendarItemsEp: string = `${this._apiSvc.endpoints.sales}/api/DeliveryCalendarItemByHeadId`;
  private _deliveryCalendarItemEp: string = `${this._apiSvc.endpoints.sales}/api/DeliveryCalendarItem`;

  constructor(
    private _apiSvc: ApiService,
    private _httpClient: HttpClient
  ) { }

  /**
   * Get calendar head
   * @param id 
   * @returns 
   */
  get(id: number): Observable<any> {
    const httpHeaders = this._apiSvc.getHttpHeaders();
    return this._httpClient.get<any>(`${this._deliveryCalendarEp}/${id}`, httpHeaders);
  }

  /**
   * Search calendar head
   * @param params 
   * @returns 
   */
  search(params: any): Observable<any> {
    return this._apiSvc.search(this._deliveryCalendarEp, params);
  }

  /**
   * Delete calendar head
   * @param id 
   * @returns 
   */
  delete(id: number): Observable<any> {
    return this._apiSvc.delete(`${this._deliveryCalendarEp}/${id}`);
  }

  /**
   * Get calendar item
   * @param itemId 
   * @returns 
   */
  getItem(itemId: number): Observable<any> {
    const httpHeaders = this._apiSvc.getHttpHeaders();
    return this._httpClient.get<any>(`${this._deliveryCalendarItemEp}/${itemId}`, httpHeaders);
  }

  /**
   * Get calendar items by head id
   * @param headId 
   * @returns 
   */
  getItems(headId: number): Observable<any> {
    const httpHeaders = this._apiSvc.getHttpHeaders();
    return this._httpClient.get<any>(`${this._deliveryCalendarItemsEp}/${headId}`, httpHeaders);
  }

  /**
   * Create calendar item
   * @param data 
   * @returns 
   */
  add(data: any): Observable<any> {

    if (data.hasOwnProperty('Id')) {
      delete data.Id;
    }

    const httpHeaders = this._apiSvc.getHttpHeaders();
    return this._httpClient.post<any[]>(this._deliveryCalendarEp, data, httpHeaders);

  }

  /**
   * Update calendar item
   * @param data 
   * @returns 
   */
  update(data: any, headId: number): Observable<any> {

    const httpHeaders = this._apiSvc.getHttpHeaders();
    return this._httpClient.put<any>(`${this._deliveryCalendarItemEp}/${headId}`, data, httpHeaders);

  }

  /**
   * Add or update calendar item
   * @param data 
   * @param id 
   * @returns 
   */
  saveItem(data: any, id?: number): Observable<any> {

    const httpHeaders = this._apiSvc.getHttpHeaders();

    const ep = id ?  `${this._deliveryCalendarItemEp}/${id}` : this._deliveryCalendarItemEp;
    const action = id ? 'put' : 'post';

    return this._httpClient[action]<any>(ep, data, httpHeaders);

  }

  /**
   * Delete calendar item
   * @param id 
   * @returns 
   */
  deleteItem(id: number): Observable<any> {
    const httpHeaders = this._apiSvc.getHttpHeaders();
    return this._httpClient.delete(`${this._deliveryCalendarItemEp}/${id}`, httpHeaders);
  }

}
